"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelMutatorNumber = void 0;
const collection_field_1 = require("../collection.field");
const number_field_1 = require("./number.field");
/** Methods to modify a number field */
class ModelMutatorNumber extends collection_field_1.ModelMutator {
    /** Set the field provided by number */
    manual(newValue) {
        if (newValue == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        let value;
        if (typeof newValue === 'string') {
            value = parseFloat(newValue);
        }
        else {
            value = newValue;
        }
        if (value == null || isNaN(value)) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_MANUAL,
            value,
        });
    }
    /** Set the value provided by bearing */
    bearing(captureId) {
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_BEARING,
            captureId,
        });
    }
    /** Set the field value provided by backbearing */
    backBearing(captureId) {
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_BACK_BEARING,
            captureId,
        });
    }
    /**
     * Set the field value provided by sag
     *
     * @param start CaptureId of the starting point
     * @param end CaptureId of the ending point
     * @param points CaptureId of the mid points
     */
    sag(start, end, points) {
        const pointIds = points.slice();
        this.state.setFieldValue(this.field.id, {
            provider: number_field_1.CollectionModelFieldNumber.PROVIDER_SAG,
            start,
            end,
            points: pointIds,
        });
    }
    /** Clone another field */
    copy(from) {
        if (from.value == null) {
            this.manual(null);
            return true;
        }
        if (from.isManual()) {
            this.manual(from.value);
            return true;
        }
        if (from.isSag()) {
            const stateValue = from.stateValue;
            this.sag(stateValue.start, stateValue.end, stateValue.points);
            return true;
        }
        if (from.isBearing()) {
            this.bearing(from.stateValue.captureId);
            return true;
        }
        if (from.isBackBearing()) {
            this.backBearing(from.stateValue.captureId);
            return true;
        }
        return false;
    }
    reverse() {
        if (!this.field.hasValue()) {
            return;
        }
        if (this.field.isBearing()) {
            // TODO: IKE Field does not support 'bearing' provider so bearings are not flipped
            return;
        }
        if (this.field.isBackBearing()) {
            // TODO: IKE Field does not support 'bearing' provider so bearings are not flipped
            return;
        }
        if (this.field.isSag()) {
            const stateValue = this.field.stateValue;
            this.sag(stateValue.end, stateValue.start, stateValue.points.slice());
            return;
        }
        // Manual numbers are not flipped
    }
}
exports.ModelMutatorNumber = ModelMutatorNumber;
//# sourceMappingURL=number.field.mutator.js.map